import utils from 'utils'
class importSettingListCtrl {
    constructor($scope, $location, logger, httpRequest) {
        $scope.importconfig = {
            label: '导入修正票种',
            code: 'IVAT_TAX4_BILL_UPDATE',
            appName: host.etcloudIvatApp,
            url: `dl/dlTaskService/import_IVAT_TAX4_BILL_UPDATE`,
            // downloadAppName: host.etcloudOvat,
            // downloadUrl: 'tax4/belleRegister/downloadRegisterUpdateTemplate',
            validate: {
                pattern: '.xlsx,.xls,.xml',
                _validate: {
                    size: {
                        min: 10,
                        max: '10MB',
                    },
                    duration: {
                        min: '10s',
                        max: '5m',
                    },
                    accept: '.xlsx,.xls,.xml',
                },
            },
            exportNegativeInvoice() {
                let _url = `${host.etcloudIvatApp}manage/ivatBill/exportNegativeInvoice?accessToken=${localStorage.getItem('id_token')}`
                utils.file_download(
                    _url,
                    {},
                    '', //type
                    'POST',
                    'blob',
                    '',
                    false
                )
            },
            callback() {},
        }
        // 初始化表单数据

        // 启用禁用请求参数
        const ableParam = {
            isValid: '',
            templateCode: '',
            templateId: '',
        }
        // 返回列表参数
        $scope.resData = []
        // 请求列表
        httpRequest.post_getFileTempletList().then((res) => {
            if (res.data.success) {
                $scope.resData = res.data.value
            }
        })

        // 按钮滑过
        $scope.dropdown_rowhover = function (row, flag) {
            row.dropdownhover = flag
        }

        // 禁用
        $scope.toEnabled = function (item, index) {
            ableParam.templateCode = item.templateCode
            ableParam.isValid = '0'
            ableParam.templateId = item.templateId
            httpRequest.post_enableAndDisableSysFileTemplet(ableParam).then((res) => {
                $scope.resData[index].isValid = '0'
                logger.logSuccess('禁用成功！')
            })
        }

        // 启用
        $scope.toAbled = function (item, index) {
            ableParam.templateCode = item.templateCode
            ableParam.isValid = '1'
            ableParam.templateId = item.templateId
            httpRequest.post_enableAndDisableSysFileTemplet(ableParam).then((res) => {
                $scope.resData[index].isValid = '1'
                logger.logSuccess('启用成功！')
            })
        }

        // 设置
        $scope.toSettingPage = function (item, index) {
            //
            $location.path(`/system/settingcenter/importSetting/add/${item.templateId}/${item.templateType}`).replace()
        }
    }
}

importSettingListCtrl.$inject = ['$scope', '$location', 'logger', 'httpRequest']
export default importSettingListCtrl



// WEBPACK FOOTER //
// ./src/app/system/settingcenter/importSetting/importSettingListCtrl.js